// import 'babel-polyfill';
import { Route, IndexRoute } from 'react-router';
import React from 'react';
import { loadWithSpinner } from './loadWithSpinner';

export function renderRouteNode({
  path = undefined,
  container = undefined,
  index = undefined,
  children = [],
  isEnabled = true,
}) {
  if (!isEnabled) {
    return '';
  }
  const getComponent = !container
    ? undefined
    : (nextState, cb) => {
        loadWithSpinner(container, cb);
      }
  return (
    <Route path={path} getComponent={getComponent}>
      {!!index && (
        <IndexRoute
          getComponent={(nextState, cb) => {
            loadWithSpinner(index, cb);
          }}
        />
      )}
      {children.length &&
        children.map(child => renderRouteNode(child)).filter(node => !!node)}
    </Route>
  );
}
